export default __webpack_public_path__ + "images/DC.830c2e7.png";